module.exports = __webpack_public_path__ + "img/bg_function04_2_m.db3505ea.png";